import { useEffect, useState } from "react";
import { useBlocker } from "react-router-dom";
import {
  fetchVersion,
  initVersionCheck,
  getInitialVersion,
} from "../../hooks/useVersionCheck";
import BaseModal from "../atoms/modal/base/BaseModal";
import Button from "../atoms/button";

export default function DeployBlocker() {
  const [isOutdated, setIsOutdated] = useState(false);

  // 앱 최초 로드 시 현재 배포 버전 저장
  useEffect(() => {
    initVersionCheck();
  }, []);

  // 페이지 이동 시도 시 가로채기
  const blocker = useBlocker(({ currentLocation, nextLocation }) => {
    return currentLocation.pathname !== nextLocation.pathname;
  });

  // 이동 시도 시 버전 체크
  useEffect(() => {
    if (blocker.state !== "blocked") return;

    fetchVersion().then((latest) => {
      const initial = getInitialVersion();
      if (latest && initial && latest !== initial) {
        setIsOutdated(true);
      } else {
        blocker.proceed();
      }
    });
  }, [blocker.state]);

  if (!isOutdated || blocker.state !== "blocked") return null;

  return (
    <BaseModal
      size="dialog"
      close={() => {}}
      enableOutsideClick={false}
      className="p-[20px]"
    >
      <section className="flex flex-col min-h-[154px]">
        <div className="w-full text-center flex-1 flex flex-col items-center justify-end mb-[40px]">
          <p className="text-[20px] font-bold">새 버전이 배포되었습니다</p>
          <p className="mt-[7px] text-[#888] text-[12px] font-[500] whitespace-pre-line">
            {"최신 버전으로 업데이트가 필요합니다.\n확인을 누르면 홈으로 이동합니다."}
          </p>
        </div>
        <Button
          className="w-full mt-auto h-[50px] text-[16px] font-bold"
          label="확인"
          variant="black"
          onClick={() => {
            window.location.href = "/";
          }}
        />
      </section>
    </BaseModal>
  );
}
